import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../state/features/userSlice";
import { selectStep } from "../state/features/stepSlice";
import { useNavigate, useParams } from "react-router-dom";
import { CSteps } from "../components/steps/steps";
import { Clock, Message } from "iconsax-react";
import execute from "../requests/frappe";
import AbstractForm from "../components/forms/abstract";
import Nprogress from "nprogress";
import {
  Steps,
  Form,
  Spin,
  Empty,
  Button,
  Checkbox,
  Input,
  Modal,
  Progress,
  message,
  Switch,
} from "antd";
import {
  CheckOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import style from "../styles/formstep.module.scss";
import clsx from "clsx";
import { searchInsert } from "../utils/insertion_point";
import ReactQuill from "react-quill";
import moment from "moment";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import { openNotification } from "../utils/notification";
import "react-quill/dist/quill.snow.css";
import { CLIENT_URL } from "../requests/config";

function hydrate_initial_repeats(placeholder = {}, amount: any) {
  const returnable = [];
  for (let i = 0; i < amount; i++) {
    returnable.push(placeholder);
  }
  return returnable;
}

function StepsIndicator({ data, change, subChange, titleVisibleChange }: any) {
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  useEffect(() => {
    titleVisibleChange?.(isTitleVisible);
  }, [isTitleVisible]);
  return (
    <div
      className={clsx(style.step_wrapper, isTitleVisible && style.fill_width)}
    >
      {data?.map((step: any, i: number) => (
        <>
          <div
            key={step}
            onClick={() => change(i)}
            className={clsx(
              style.step_item,
              isTitleVisible && style.name_visible
            )}
          >
            <div
              className={clsx(
                style.step_indicator_container,
                step.curr > i &&
                (step.status === "error"
                  ? style.step_indicator_container_error_active
                  : style.step_indicator_container_active),
                step.subTasks.length > 0 &&
                style.step_indicator_container_hidden
              )}
            >
              <div
                className={clsx(
                  style.step_indicator,
                  style.step_indicator_big,
                  step.selected && style.step_indicator_big_selected,
                  step.status === "error" &&
                  (step.selected
                    ? style.step_indicator_big_selected_error
                    : style.step_indicator_big_error)
                )}
              >
                {step.status === "finish" ? <CheckOutlined /> : i + 1}
              </div>
            </div>
            <span
              className={clsx(
                style.title_container,
                style.title_container_primary,
                step.selected && style.title_container_primary_active
              )}
            >
              {step.title}
            </span>
          </div>
          {step.subTasks.map((tsk: any, j: number) => (
            <div
              key={tsk}
              onClick={() => {
                change(i);
                document.getElementById(tsk.uid)?.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }}
              className={clsx(
                style.step_item,
                isTitleVisible && style.name_visible
              )}
            >
              <div
                className={clsx(
                  style.step_indicator_container,
                  style.step_indicator_container_inner,
                  (step.curr > i || step.currSub > j) &&
                  (tsk.status === "error"
                    ? style.step_indicator_container_error_active
                    : style.step_indicator_container_active)
                )}
              >
                <div
                  className={clsx(
                    style.step_indicator,
                    style.step_indicator_small,
                    tsk.selected && style.step_indicator_small_selected,
                    tsk.status === "error" &&
                    (step.selected
                      ? style.step_indicator_small_selected_error
                      : style.step_indicator_small_error)
                  )}
                />
              </div>
              <span
                className={clsx(
                  style.title_container,
                  style.title_container_secondary,
                  tsk.selected && style.title_container_secondary_active,
                  tsk.status === "error" &&
                  style.title_container_secondary_error
                )}
              >
                {tsk.title}
              </span>
            </div>
          ))}
        </>
      ))}
      <button
        className={style.show_title}
        onClick={() => {
          setIsTitleVisible(!isTitleVisible);
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isTitleVisible ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
        </div>
      </button>
    </div>
  );
}

function generateFileObject(fakePath: any) {
  // Extracting file name from the fake path
  const fileName = fakePath.split("\\").pop();

  // Creating a unique UID
  const uid = `rc-upload-${Date.now()}`;

  // Generating the response object
  const response = {
    data: [
      {
        fieldname: "file",
        originalname: fileName,
        encoding: "7bit",
        mimetype: "image/png",
        destination: "./public/uploads",
        filename: `${uid}${fileName}`,
        path: `public/uploads/${uid}${fileName}`,
        size: 271706,
      },
    ],
    name: fileName,
    url: `${CLIENT_URL}/uploads/${uid}${fileName}`,
  };

  // Creating the final file object
  const fileObject = {
    uid,
    lastModified: Date.now(),
    lastModifiedDate: new Date().toISOString(),
    name: fileName,
    size: 271706,
    type: "image/png",
    percent: 100,
    originFileObj: { uid },
    status: "done",
    response,
    xhr: {},
  };

  return [fileObject];
}

export const Evaluation = () => {
  const user = useSelector(selectUser);
  const isLoggedIn = !!user;
  const selectedStep = useSelector(selectStep);
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState<any>("");
  const [parsedData, setParsedData] = useState<any>(null);
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const [validation, setValidation] = useState<any>({});
  const [customTable, setCustomTable] = useState<any>({});
  const [currField, setCurrField] = useState(0);
  const [comment, setComment] = useState("");
  const [evalOutput, setEvalOutput] = useState("");
  const [percentageComplete, setPercentageComplete] = useState<number>(0);
  const defaultCheckedList = ["Comment", "Send SMS"];
  const [checkedList, setCheckedList] =
    useState<CheckboxValueType[]>(defaultCheckedList);
  const [currTab, setCurrent] = useState(data?.steps?.current || 0);
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const [AdditionalFiles, setAdditionalFiles] = useState<number[]>([]);

  const formRef = useRef<any>();
  const { Step } = Steps;

  const form = useMemo(() => {
    /**
     * @type {[]}
     */
    const $form = data?.evaluators_form
      ? data?.form_to_be_filled_by_evaluator?.form
      : data?.form?.form;
    for (let i = 0; i < $form?.length; i++) {
      $form[i].titles = $form[i]?.fields.reduce(
        (prev: any, fld: any, i: number) => {
          const out = prev;
          const type = fld.type || fld.data?.type;
          if (type === "title") {
            out.push(i);
          }
          return out;
        },
        []
      );
    }

    return $form;
  }, [data?.form]);

  const prev_data = data?.second_form_raw_data && {
    ...JSON.parse(data?.second_form_raw_data),
    ...data?.form?.form
      ?.reduce((prev: any, curr: any) => [...prev, ...curr.fields], [])
      ?.filter(
        (field: any) =>
          field?.data?.type === "group" &&
          !(JSON.parse(data?.second_form_raw_data)?.[field.uid]?.length > 0)
      )
      ?.reduce(
        (prev: any, curr: any) => ({
          ...prev,
          [curr.uid]: hydrate_initial_repeats(
            {},
            curr.data?.minimum_repeats || 0
          ),
        }),
        {}
      ),
  };

  const handleTextAreaChange = (
    content: any,
    delta: any,
    source: any,
    editor: any
  ) => {
    setComment(content);
  };

  const handleEvalOutputChange = (
    content: any,
    delta: any,
    source: any,
    editor: any
  ) => {
    setEvalOutput(content);
  };

  const handleSendComment = async () => {
    if (comment?.trim() === "") {
      openNotification("Error", "Comment is empty.", "error");
      return; // Prevent sending the comment
    }

    if (checkedList.length === 0) {
      openNotification(
        "Error",
        "Please select at least one checkbox.",
        "error"
      );

      return; // Prevent sending the comment
    }

    await execute("SEND_COMMENT", {
      evaluation: data?.evaluation_data?.name,
      email: user?.email,
      comment: comment,
      type: checkedList,
      to: data?.webuser?.mobile_number,
    });

    setComment("");
    setFetchTrigger((prev) => prev + 1);
  };

  const onChange = (list: CheckboxValueType[]) => {
    setCheckedList(list);
  };

  const toggleOnChange = async (checked: boolean) => {
    const temp_data = await execute("UPDATE_MISSING_FORM_VISIBILITY", {
      submission: params?.app,
      step_name: params?.step,
      applicant: params?.user,
      step_id: params?.stepid,
      missing_form: checked ? 1 : 0,
    });
    if (temp_data.status && checked) {
      openNotification(
        "Success",
        "Successfully enabled the additional form field for the user",
        "success"
      );
    } else if (temp_data.status && !checked) {
      openNotification(
        "Success",
        "Successfully disabled the additional form field for the user",
        "success"
      );
    }
  };

  const Fetch_Data = async () => {
    const temp_data = await execute("GET_EVALUATION_DATA", {
      submission: params?.app,
      step_name: params?.step,
      applicant: params?.user,
      step_id: params?.stepid,
    });
    setData(temp_data);
    setEvalOutput(temp_data?.evaluation_data?.html_output_text || "");
    setParsedData(temp_data?.initial_values);
  };

  useEffect(() => {
    if (fetchTrigger > 0 || (data === "" && user)) {
      Fetch_Data();
    }
  }, [fetchTrigger, user]);

  useEffect(() => {
    // Set up an interval to run the useEffect every 1000 milliseconds (1 second)
    const intervalId = setInterval(() => {
      let timer_waiter: number | any;
      if (typeof window !== "undefined") {
        (window as any).rf = formRef.current;
      }
      if (typeof window !== "undefined") {
        let new_valid = 0,
          new_total = 0;
        if (customTable) {
          const values = (formRef?.current as any)?.getFieldsValue() || {};
          form
            ?.reduce((prev: any, curr: any, i: number, arr: any) => {
              return [...prev, ...curr.fields];
            }, [])
            ?.map(
              (fld: any) => {
                if (
                  ["title", "colend", "colstart"].indexOf(
                    fld?.type || fld?.data?.type
                  ) !== -1
                ) {
                  return;
                }

                const countable = customTable[fld.name]
                  ? 1
                  : fld.conditions.length > 0
                    ? 1
                    : (typeof values[fld.name] != "undefined" &&
                      values[fld.name] !== null) === true
                      ? 1
                      : 0;

                new_valid += countable;
                new_total += 1;
              },
              [0, 0]
            );

          setPercentageComplete(
            parseFloat(((new_valid / new_total) * 100).toFixed(1))
          );
        }

        (window as any).validateAllForm = async (
          _value: any,
          _fld_vals = null,
          $error_list = null,
          step_id = null
        ) => {
          clearTimeout(timer_waiter);
          const timed_await = async () => {
            const values =
              _fld_vals || (formRef?.current as any)?.getFieldsValue() || {};

            if (!_fld_vals) {
              setCurrField(_value);
              let valid = 0,
                total = 0;

              form
                .reduce((prev: any, curr: any, i: number, arr: any) => {
                  return [...prev, ...curr.fields];
                }, [])
                .map(
                  (fld: any) => {
                    if (
                      ["title", "colend", "colstart"].indexOf(
                        fld?.type || fld?.data?.type
                      ) !== -1
                    ) {
                      return;
                    }
                    const countable = customTable[fld.name]
                      ? 1
                      : fld.conditions.length > 0
                        ? 1
                        : (typeof values[fld.name] != "undefined" &&
                          values[fld.name] !== null) === true
                          ? 1
                          : 0;
                    valid += countable;
                    total += 1;
                  },
                  [0, 0]
                );

              setPercentageComplete(
                parseFloat(((valid / total) * 100).toFixed(1))
              );
            }

            const error_list =
              $error_list || (formRef?.current as any)?.getFieldError(_value);
            if ((error_list?.length || 0) === 0) {
              const validity = validation || {};
              if (!_fld_vals) {
                validity[currTab] = { ...(validity[currTab] || {}) };
                if (validity[currTab]) {
                  validity[currTab][_value] = true;

                  setValidation({ ...{ ...validity } });
                }
              } else {
                return true;
              }
            } else {
              const validity = validation || {};
              if (!_fld_vals) {
                validity[currTab] = { ...(validity[currTab] || {}) };
                if (validity[currTab]) {
                  validity[currTab][_value] = error_list
                    .map((err: any) => `- ${err}\n`)
                    .join("");
                  setValidation({ ...{ ...validity } });
                }
              } else {
                return error_list.map((err: any) => `- ${err}\n`).join("");
              }
            }
          };
          if (_fld_vals) {
            const $validation = await timed_await();

            timer_waiter = setTimeout(() => {
              let valid = 0,
                total = 0;
              const values =
                _fld_vals || (formRef?.current as any)?.getFieldsValue() || {};
              form
                .reduce((prev: any, curr: any, i: number, arr: any) => {
                  return [...prev, ...curr.fields];
                }, [])
                .map(
                  (fld: any) => {
                    if (
                      ["title", "colend", "colstart"].indexOf(
                        fld?.type || fld?.data?.type
                      ) !== -1
                    ) {
                      return;
                    }

                    const countable = customTable[fld.name]
                      ? 1
                      : fld.conditions.length > 0 || !(fld.required || false)
                        ? 1
                        : (typeof values[fld.name] != "undefined" &&
                          values[fld.name] !== null) === true
                          ? 1
                          : 0;
                    valid += countable;
                    total += 1;
                  },
                  [0, 0]
                );

              setPercentageComplete(
                parseFloat(((valid / total) * 100).toFixed(1))
              );
            }, 600);
            return $validation;
          } else {
            timer_waiter = setTimeout(timed_await, 400);
          }
        };
        (window as any).validateAllFields = async () => {
          try {
            await (window as any).rf.validateFields();
          } catch (e: any) {
            const $val_map = form.reduce((prev: any, curr: any, i: number) => {
              return [...prev, curr.fields.map((fld: any) => fld.uid)];
            }, []);
            const $validations = await Promise.all(
              e.errorFields.map(async ({ name: _fl_name, errors }: any) => {
                return {
                  name: _fl_name.join("."),
                  value: await (window as any).validateAllForm(
                    _fl_name.join("."),
                    e.values,
                    errors
                  ),
                };
              })
            );

            const $_valid = $validations.reduce((prev, curr, i) => {
              const $f_tab = $val_map
                .map(($curr: any, $i: any) => ({
                  fld: $curr,
                  id: $i,
                }))
                .filter(($map: any) => {
                  const $v_fld_name = curr.name?.split?.(".")?.[0] || curr.name;
                  return $map.fld.indexOf($v_fld_name) !== -1;
                })[0]?.id;
              return {
                ...prev,
                [$f_tab]: {
                  ...(prev?.[$f_tab] || {}),
                  [curr.name?.split?.(".")?.[0] || curr.name]: curr.value,
                },
              };
            }, {});
            setValidation($_valid);
          }
        };
      }
    }, 2000);

    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [currTab, customTable, form]);

  if (!isLoggedIn || !data) {
    return (
      <div className=" w-full flex items-center justify-center mt-[20%]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {isLoggedIn && data && (
        <div className="w-full mt-[1%] bg-general_bg grid grid-cols-3 xl:grid-cols-4">
          <div className=" col-span-4 xl:col-span-3 mr-[1%] mb-[5%]">
            {/* header section with the action buttons */}
            <div className=" flex justify-between items-center">
              <div className=" max-w-[80%] truncate">
                <span
                  className="text-[#00000073] hover:text-blue cursor-pointer"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home / Application assigned
                </span>{" "}
                / {data?.evaluation_data?.name}
              </div>
              <div className=" flex justify-end w-[40%]">
                <p className="flex items-center">
                  Allow addition of files:
                  <Switch
                    className=" ml-2 mr-5 self-center bg-step_grey"
                    onChange={toggleOnChange}
                    // disabled={!data?.current_form_submitted}
                    defaultChecked={data?.evaluation_data?.missing_file === 1}
                  />
                </p>
                {data?.first_step && (
                  <button
                    className={`px-[4%] mr-[5%] py-2 rounded-md text-white bg-red_btn`}
                    onClick={async () => {
                      if (!isRequestSent) {
                        setIsRequestSent(true);

                        try {
                          Modal.confirm({
                            title: "Confirm",
                            // icon: <ExclamationCircleOutlined />,
                            content: (
                              <div>Are you sure you want to reject it.</div>
                            ),
                            okText: "Yes",
                            okButtonProps: {
                              style: {
                                backgroundColor: "#1890FF",
                              },
                            },
                            cancelText: "No",
                            onCancel() { },
                            async onOk() {
                              const temp_resp = await execute(
                                "REJECT_EVALUATION",
                                {
                                  name: data?.evaluation_data?.name,
                                  html_output_text: evalOutput,
                                }
                              );
                              navigate(`/`);
                            },
                          });
                        } catch (error) {
                          console.error("Error while sending request", error);
                        }
                      }
                    }}
                  // disabled={
                  //   !data?.form_step ||
                  //   (data?.second_form_raw_data &&
                  //     JSON.parse(data?.second_form_raw_data)[data?.form_step])
                  //     ? false
                  //     : true
                  // }
                  >
                    Adjust
                  </button>
                )}

                {data?.last_step && (
                  <button
                    className={`px-[4%] mr-[5%] py-2 rounded-md text-white ${!data?.form_step ||
                        (data?.current_form_submitted && data?.evaluators_form)
                        ? "bg-blue_btn"
                        : "cursor-not-allowed bg-[#B0C4DE]"
                      }`}
                    onClick={async () => {
                      navigate(`/certificate/${data?.uac}/${params?.user}`);
                    }}
                    disabled={
                      !data?.form_step ||
                        (data?.current_form_submitted && data?.evaluators_form)
                        ? false
                        : true
                    }
                  >
                    Preview Certificate
                  </button>
                )}

                <button
                  className={`px-[4%] py-2 rounded-md text-white ${!data?.form_step || data?.current_form_submitted
                      ? "bg-green_btn"
                      : "cursor-not-allowed bg-[#B0C4DE]"
                    }`}
                  onClick={async () => {
                    if (!isRequestSent) {
                      setIsRequestSent(true);

                      try {
                        Modal.confirm({
                          title: "Confirm",
                          // icon: <ExclamationCircleOutlined />,
                          content: (
                            <div>Are you sure you want to approve it.</div>
                          ),
                          okText: "Yes",
                          okButtonProps: {
                            style: {
                              backgroundColor: "#1890FF",
                            },
                          },
                          cancelText: "No",
                          onCancel() { },
                          async onOk() {
                            const temp_resp = await execute(
                              "SUBMIT_EVALUATION",
                              {
                                name: data?.evaluation_data?.name,
                                html_output_text: evalOutput,
                                step: selectedStep,
                              }
                            );
                            if (data.last_step) {
                              navigate(`/`, {
                                replace: true,
                              });
                            }
                            navigate(`/application/${params.app}`, {
                              replace: true,
                            });
                          },
                        });
                      } catch (error) {
                        console.error("Error while sending request", error);
                      }
                    }
                  }}
                  disabled={
                    !data?.form_step || data?.current_form_submitted
                      ? false
                      : true
                  }
                >
                  Approve
                </button>
              </div>
            </div>
            {/* Section that contains the details of the application and the evaluation step */}
            <div className="bg-white mt-[1%] ">
              <div className="p-4 grid md:grid-cols-5 gap-7">
                <p className=" md:grid md:grid-cols-5 col-span-4 font-[700]">
                  Application Name:
                  <span className=" ml-2 col-span-4">{params.app}</span>
                </p>
                <p className=" col-span-1"> UAC: {data?.uac}</p>
              </div>
              <div className=" xsm:p-4 border-y-[1px]">
                <CSteps steps={{ ...data?.steps, disabled: true }} />
              </div>
              <div className="p-4 border-b-[1px] xsm:flex justify-between">
                <div className=" font-semibold py-1">
                  TODO
                  <span
                    className=" font-normal text-[#494949]"
                    dangerouslySetInnerHTML={{
                      __html: data?.evaluation_data?.req_html_hidden,
                    }}
                  ></span>
                </div>
              </div>
              <div className="p-4 border-b-[1px]">
                <span className=" font-semibold mb-2">Submission Info</span>
                <div className="grid grid-cols-2 mt-5 gap-10">
                  <div className=" col-span-2 md:col-span-1 grid">
                    <span className="font-semibold mb-2">Service</span>
                    <p className=" mb-5 text-[#494949]">
                      {data?.evaluation_data?.service}
                    </p>
                    <span className="font-semibold mb-2">Application</span>
                    <p className="text-[#494949]">
                      {data?.evaluation_data?.submission}
                    </p>
                  </div>
                  <div className=" col-span-2 md:col-span-1 grid">
                    <span className="font-semibold mb-2">Step Name</span>
                    <p className=" mb-5 text-[#494949]">
                      {data?.evaluation_data?.step_name}
                    </p>
                    <span className="font-semibold mb-2">Type</span>
                    <p className="text-[#494949]">
                      {data?.evaluation_data?.type}
                    </p>
                  </div>
                </div>
              </div>
              <div className=" p-4 grid">
                <span className="font-semibold mb-2">User</span>
                <p className=" mb-5 text-[#494949]">{data?.user}</p>
              </div>
            </div>
            {/* section for displaying the Empty icon if their is no data filled by the client  */}

            {data?.form_step &&
              !data?.evaluators_form &&
              (!JSON.parse(data?.second_form_raw_data) ||
                !JSON.parse(data?.second_form_raw_data)[data?.form_step]) && (
                <div className=" pt-[10%] pb-[10%] w-full flex items-center justify-center bg-white">
                  <Empty
                    description={
                      <span className=" mt-3">
                        The applicant did not fill in the required information.
                      </span>
                    }
                  />
                </div>
              )}

            {!data?.form_step ||
              ((data?.second_form_raw_data || data?.evaluators_form) &&
                ((data?.second_form_raw_data &&
                  data?.form_step &&
                  JSON.parse(data.second_form_raw_data)?.[data.form_step]) ||
                  data?.evaluators_form) && (
                  <div className="md:pl-4 grid grid-cols-5 mt-7 bg-white">
                    <div className=" mt-10 col-span-5 md:col-span-1 hidden md:grid">
                      <StepsIndicator
                        titleVisibleChange={(is_vis: boolean) => {
                          setIsTitleVisible(is_vis);
                        }}
                        data={form?.map((step: any, i: number) => ({
                          title: step.title,
                          status: form[i]?.fields?.some((fld: any) => {
                            if (
                              ["title", "colend", "colstart"].indexOf(
                                fld?.type || fld?.data?.type
                              ) !== -1
                            ) {
                              return false;
                            }
                            return (
                              typeof validation?.[i]?.[fld.name] === "string"
                            );
                          })
                            ? "error"
                            : form[i]?.fields?.every((fld: any) => {
                              if (
                                ["title", "colend", "colstart"].indexOf(
                                  fld?.type || fld?.data?.type
                                ) !== -1
                              ) {
                                return true;
                              }
                              return validation?.[i]?.[fld.name] === true;
                            })
                              ? "finish"
                              : "wait",
                          selected: currTab === i,
                          curr: currTab,
                          currSub:
                            searchInsert(
                              form[i].titles,
                              form[i]?.fields.findIndex(
                                (fld: any) => fld.uid === currField
                              )
                            ) - 1,
                          subTasks: form[i]?.fields
                            ?.filter((fld: any) => fld.type === "title")
                            .map((fld: any, k: number) => ({
                              uid: fld.uid,
                              title: fld.label,
                              selected:
                                currTab === i &&
                                k ===
                                searchInsert(
                                  form[i].titles,
                                  form[i]?.fields.findIndex(
                                    (fld: any) => fld.uid === currField
                                  )
                                ) -
                                1,
                              status: form[i]?.fields
                                ?.slice(
                                  form[i].titles[k],
                                  form[i].titles?.[k + 1]
                                )
                                ?.some((fld: any) => {
                                  if (
                                    ["title", "colend", "colstart"].indexOf(
                                      fld.type || fld.data.type
                                    ) !== -1
                                  ) {
                                    return false;
                                  }
                                  return (
                                    typeof validation?.[i]?.[fld.name] ===
                                    "string"
                                  );
                                })
                                ? "error"
                                : form[i]?.fields
                                  ?.slice(
                                    form[i].titles[k],
                                    form[i].titles?.[k + 1]
                                  )
                                  ?.every((fld: any) => {
                                    if (
                                      ["title", "colend", "colstart"].indexOf(
                                        fld.type || fld.data.type
                                      ) !== -1
                                    ) {
                                      return true;
                                    }
                                    return (
                                      validation?.[i]?.[fld.name] === true
                                    );
                                  })
                                  ? "finish"
                                  : "wait",
                            })),
                        }))}
                        change={(cc: number) => setCurrent(cc)}
                        current={currTab}
                      />

                      <div className="flex flex-col items-center pb-5">
                        <Progress
                          type="circle"
                          percent={percentageComplete}
                          strokeColor={"#0050b3"}
                          trailColor={"#fff"}
                          style={{ background: "#00000008", borderRadius: 90 }}
                          status="active"
                        />
                        <span className="text-[13px] text-gray-500 my-6">
                          Form Completeness
                        </span>

                        <button
                          onClick={(event) => {
                            Nprogress.start();
                            const loading_ref = message.loading(
                              "Submitting your application",
                              0
                            );
                            console.log("Submit is clicked");
                            Object.keys(customTable).map((cond) => {
                              formRef.current.setFieldsValue({
                                [cond]: customTable[cond],
                              });
                            });
                            const formValues = formRef.current.getFieldsValue();
                            // Merge customTable values into formValues for logging
                            const allFormValues = {
                              ...formValues,
                              ...customTable,
                            };
                            console.log("Submitted form values:", allFormValues);
                            console.log("Custom table values:", customTable);
                            formRef.current
                              .validateFields()
                              .then(async (values: any) => {
                                console.log("Submit event is here ");
                                event.preventDefault();
                                
                                // Merge customTable values into values
                                const mergedValues = {
                                  ...values,
                                  ...customTable,
                                };
                                
                                Object.keys(mergedValues).map((key) => {
                                  const value = mergedValues[key];
                                  if (typeof value === "undefined") {
                                    mergedValues[key] = null;
                                  }
                                });
                                try {
                                  const test_ = await (
                                    await fetch(
                                      `${CLIENT_URL}/api/live_save_next_form`,
                                      {
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Access-Control-Allow-Origin": "*",
                                        },
                                        method: "POST",
                                        body: JSON.stringify({
                                          change: mergedValues,
                                          service:
                                            data?.evaluation_data?.service,
                                          formname: data?.form?.title?.trim(),
                                          uac: data?.uac,
                                          step: selectedStep + 1,
                                          userId: params?.user,
                                        }),
                                      }
                                    )
                                  ).json();
                                  const res = await fetch(
                                    `${CLIENT_URL}/api/uploadForm_next?formname=${data?.form?.title?.trim()}&&uac=${
                                      data?.uac
                                    }&&step=${selectedStep + 1}&&userId=${
                                      params?.user
                                    }`,
                                    {
                                      headers: {
                                        "Content-Type": "application/json",
                                        "Access-Control-Allow-Origin": "*",
                                      },
                                      method: "POST",
                                      body: JSON.stringify(
                                        mergedValues,  // Use mergedValues instead of values
                                        (key, value) => {
                                          if (typeof value === "undefined") {
                                            return null; // or any other desired value
                                          }
                                          return value;
                                        }
                                      ),
                                    }
                                  );
                                  const result = await res.json();
                                  if (res.status === 200) {
                                    loading_ref();
                                    Nprogress.done();
                                    message.success(
                                      "Form successfully submitted!"
                                    );
                                    window.location.reload();
                                  } else {
                                    throw "Something went wrong!";
                                  }
                                } catch (e) {
                                  loading_ref();
                                  Nprogress.done();
                                  message.error("Something went wrong!");
                                }
                              })
                              .catch(async (errorInfo: any) => {
                                loading_ref();
                                Nprogress.done();
                                message.error(
                                  errorInfo.errorFields.length +
                                  "fields are not fully complete"
                                );
                              });
                          }}
                          className={`py-2 px-6 min-w-110 inline-flex items-center justify-center w-auto font-light rounded-md text-base bg-[#73D13D] text-white transition-all duration-300 focus:outline-none focus:ring focus:border-blue-300 active:bg-green-700 hover:bg-green-600 ${data?.current_form_submitted ? "hidden" : ""
                            }`}
                        >
                          Submit
                        </button>
                      </div>
                    </div>

                    <div className="bg-white col-span-5 md:col-span-4 pt-4 pl-7 mb-20">
                      {prev_data &&
                        prev_data[
                        data?.form?.title?.trim() + String(selectedStep + 1)
                        ] &&
                        data?.current_form_submitted && (
                          <Form
                            className="pt-4 pr-7"
                            hideRequiredMark={false}
                            initialValues={
                              prev_data[
                              data?.form?.title?.trim() +
                              String(selectedStep + 1)
                              ]
                            }
                            ref={formRef}
                            labelAlign={"left"}
                            validateTrigger={"onChange"}
                            layout={"vertical"}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flex: 1,
                              marginBottom: "20px",
                            }}
                          >
                            {currTab === 0}
                            {form?.map((step: any, i: number) => (
                              <AbstractForm
                                key={i}
                                disabled={true}
                                secondary_form={true}
                                prev_data={
                                  prev_data[
                                  data?.form?.title?.trim() +
                                  String(selectedStep + 1)
                                  ]
                                }
                                form={formRef}
                                visible={i === currTab}
                                fields={step.fields}
                                current_form={data?.form_step}
                                // onValueChange={() => {
                                //   console.log("none");
                                // }}
                                onValueChange={(newData: any, field_id: string) => {
                                  setCustomTable((prev: any) => ({
                                    ...prev,
                                    [field_id]: newData,
                                  }));
                                }}
                              />
                            ))}
                            <div style={{ flex: 1, width: 0 }} />
                            <div className="">
                              {currTab < form?.length - 1 && (
                                <div
                                  onClick={() => {
                                    setCurrent(currTab + 1);
                                  }}
                                  className="bg-[#096DD9] w-[20%] flex justify-center py-2 rounded-md text-white cursor-pointer"
                                >
                                  Next
                                </div>
                              )}

                              {currTab > 0 && (
                                <div
                                  onClick={() => {
                                    setCurrent(currTab - 1);
                                  }}
                                  className="bg-white w-[20%] flex justify-center py-2 rounded-md text-black cursor-pointer border-[1px] hover:text-blue hover:border-blue"
                                >
                                  Back
                                </div>
                              )}
                            </div>
                            <div
                              onClick={async () => {
                                Nprogress.start();
                                const loading_ref = message.loading(
                                  "Saving your application",
                                  0
                                );
                                const values =
                                  await formRef.current.getFieldsValue();

                                Object.keys(customTable).map((cond) => {
                                  values[cond] = customTable[cond];
                                });

                                Object.keys(values).map((key) => {
                                  const value = values[key];
                                  if (typeof value === "undefined") {
                                    values[key] = null;
                                  }
                                });
                                try {
                                  const result = await (
                                    await fetch(
                                      `${CLIENT_URL}/api/live_save_next_form`,
                                      {
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Access-Control-Allow-Origin": "*",
                                        },
                                        method: "POST",
                                        body: JSON.stringify({
                                          change: values,
                                          service:
                                            data?.evaluation_data?.service,
                                          formname: data?.form?.title?.trim(),
                                          uac: data?.uac,
                                          step: String(selectedStep + 1),
                                          userId: params?.user,
                                        }),
                                      }
                                    )
                                  ).json();

                                  if (result.error === 1) {
                                    loading_ref();
                                    Nprogress.done();
                                  } else {
                                    loading_ref();
                                    message.success(
                                      "Application successfully saved!"
                                    );
                                    Nprogress.done();
                                  }
                                } catch (e) {
                                  loading_ref();
                                  message.error("Could not save document!");
                                  Nprogress.done();
                                }
                              }}
                              className={`cursor-pointer px-8 py-2 min-w-180 w-fit font-light rounded-md text-base text-black hover:bg-[#00000008] ${data?.current_form_submitted ? "hidden" : ""
                                }`}
                            >
                              Save and Continue Later
                            </div>
                            <h1 className="mt-5 text-[30px] font-semibold">
                              Additional Files
                            </h1>
                            {data?.additional_files?.map(
                              (file: any, index: number) => {
                                return (
                                  <div className=" ">
                                    <p
                                      className=" border-[1px] bg-[#F5F5F5] mt-5 mb-2 p-2 flex justify-between items-center cursor-pointer"
                                      onClick={() => {
                                        if (AdditionalFiles.includes(index)) {
                                          const newArray =
                                            AdditionalFiles.filter(
                                              (item: number) => item !== index
                                            );
                                          // Update the state with the new array
                                          setAdditionalFiles(newArray);
                                        } else {
                                          setAdditionalFiles([
                                            ...AdditionalFiles,
                                            index,
                                          ]);
                                        }
                                      }}
                                    >
                                      {file?.attachment_name}
                                      {AdditionalFiles.includes(index) ? (
                                        <UpOutlined />
                                      ) : (
                                        <DownOutlined />
                                      )}
                                    </p>
                                    <embed
                                      className={`${AdditionalFiles.includes(index)
                                          ? ""
                                          : "hidden"
                                        }`}
                                      src={`${window.location.protocol === "https:"
                                          ? file?.url
                                          : file?.url.replace("https", "http")
                                        }`}
                                      // src="https://www.africau.edu/images/default/sample.pdf"
                                      width="100%"
                                      height="600px"
                                    // onLoad={() => this.handleLoad(field_id)}
                                    />
                                  </div>
                                );
                              }
                            )}

                            {!data?.additional_files && (
                              <div className="">
                                <Empty
                                  description={
                                    <span className=" mt-3">
                                      No Additional files Found.
                                    </span>
                                  }
                                />
                              </div>
                            )}
                          </Form>
                        )}
                      {data.evaluators_form &&
                        !data?.current_form_submitted && (
                          <Form
                            className="pt-4 pr-7"
                            hideRequiredMark={false}
                            ref={formRef}
                            labelAlign={"left"}
                            validateTrigger={"onChange"}
                            layout={"vertical"}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flex: 1,
                              marginBottom: "20px",
                            }}
                            initialValues={parsedData ? parsedData : {}}
                          >
                            {currTab === 0}
                            {form?.map((step: any, i: number) => (
                              <AbstractForm
                                key={i}
                                // disabled={true}
                                secondary_form={true}
                                prev_data={parsedData ? parsedData : {}}
                                form={formRef}
                                visible={i === currTab}
                                fields={step.fields}
                                current_form={data?.form_step}
                                // onValueChange={(e: any) => {
                                //   console.log("object render ----->");
                                // }}
                                onValueChange={(newData: any, field_id: string) => {
                                  setCustomTable((prev: any) => ({
                                    ...prev,
                                    [field_id]: newData,
                                  }));
                                }}
                              />
                            ))}
                            <div style={{ flex: 1, width: 0 }} />
                            <div className="">
                              {currTab < form?.length - 1 && (
                                <div
                                  onClick={() => {
                                    setCurrent(currTab + 1);
                                  }}
                                  className="bg-[#096DD9] w-[20%] flex justify-center py-2 rounded-md text-white cursor-pointer"
                                >
                                  Next
                                </div>
                              )}

                              {currTab > 0 && (
                                <div
                                  onClick={() => {
                                    setCurrent(currTab - 1);
                                  }}
                                  className="bg-white w-[20%] flex justify-center py-2 rounded-md text-black cursor-pointer border-[1px] hover:text-blue hover:border-blue"
                                >
                                  Back
                                </div>
                              )}
                            </div>
                          </Form>
                        )}
                    </div>
                  </div>
                ))}

            <div className="md:pl-4 mt-7 p-5 bg-white min-h-[400px] ">
              <div className="mr-7 grid h-fit ">
                {data?.evaluation_data?.input_html_hidden && (
                  <span className=" font-semibold text-[17px] mb-2">
                    Requested Data
                  </span>
                )}
                {data?.evaluation_data?.input_html_hidden && (
                  <p
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: data?.evaluation_data?.input_html_hidden,
                    }}
                  ></p>
                )}
                <span className=" font-semibold text-[17px] mb-5">
                  Evaluation Output
                </span>
                <ReactQuill
                  className=" h-60 mb-10"
                  theme="snow"
                  value={evalOutput}
                  onChange={handleEvalOutputChange}
                />
              </div>
            </div>
          </div>

          <div className=" col-span-4 xl:col-span-1 mt-10 xl:mt-0">
            <div className=" px-3 mb-10 bg-white nxl:mr-14 rounded-md">
              <h2 className=" font-semibold py-4">Officer Comment</h2>
              <div className=" h-72">
                <ReactQuill
                  className=" h-52"
                  theme="snow"
                  value={comment}
                  onChange={handleTextAreaChange}
                />
              </div>
              <Checkbox.Group
                className=" w-[90%] my-3 justify-between"
                value={checkedList}
                onChange={onChange}
              >
                <Checkbox value="Comment">Comment</Checkbox>
                <Checkbox value="Send SMS">Send SMS</Checkbox>
              </Checkbox.Group>
              <Button className=" h-10 my-3 w-full" onClick={handleSendComment}>
                Send Comment
              </Button>
            </div>
            <h2 className="ml-3 mb-8 font-semibold">Activity Log</h2>
            <Steps
              className=" xl:max-h-[400px] xl:overflow-y-scroll no-scrollbar mb-20"
              direction="vertical"
              current={100000}
            >
              {data?.activity_log?.map((log: any) => {
                if (log.data) {
                  return (
                    log.data && (
                      <Step
                        key={log.name}
                        icon={<Clock size={14} />}
                        description={
                          <div className=" bg-white mr-14 rounded-md">
                            {Object.keys(log?.data).map((alter_type: any) => {
                              const wordsToRemove = ["_", "html"];
                              // Create a regular expression pattern by joining the words with '|' to match any of them
                              const pattern = new RegExp(
                                wordsToRemove.join("|"),
                                "gi"
                              );

                              if (log.data[alter_type]?.length > 0) {
                                return (
                                  <div className=" text-black">
                                    <div className=" flex px-4 py-3">
                                      <span className=" font-semibold">
                                        You
                                      </span>
                                      <p className="ml-4 text-gray-500">
                                        {moment(log.creation).fromNow()}
                                      </p>
                                    </div>
                                    <div className=" px-4 h-fit w-fit pb-3 font-semibold flex flex-wrap items-center ">
                                      <span className=" pr-2 font-normal">
                                        {alter_type.replace(pattern, " ")}
                                      </span>
                                      {log.data[alter_type][0].replace(
                                        pattern,
                                        " "
                                      )}
                                      <span className=" px-1 font-normal">
                                        from
                                      </span>
                                      {log.data[alter_type][1]
                                        ? log.data[alter_type][1]
                                        : "None"}
                                      <span className=" px-1 font-normal">
                                        to
                                      </span>
                                      <p
                                        className=" font-normal"
                                        dangerouslySetInnerHTML={{
                                          __html: log.data[alter_type][2],
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        }
                      />
                    )
                  );
                }

                if (log.content) {
                  return (
                    log.content && (
                      <Step
                        key={log.name}
                        icon={<Message size={14} />}
                        description={
                          <div className=" bg-white mr-14 rounded-md">
                            <div className=" text-black">
                              <div className=" flex px-4 py-2">
                                <span className=" font-semibold">You</span>
                                <p className="ml-4 text-gray-500">
                                  {moment(log.creation).fromNow()}
                                </p>
                              </div>
                              <p
                                className=" px-4 pb-3 font-normal"
                                dangerouslySetInnerHTML={{
                                  __html: log.content,
                                }}
                              />
                            </div>
                          </div>
                        }
                      />
                    )
                  );
                }
              })}
            </Steps>
          </div>
        </div>
      )}
    </>
  );
};
